import { render, staticRenderFns } from "./page-action-bar.vue?vue&type=template&id=7af66373&scoped=true"
import script from "./page-action-bar.vue?vue&type=script&lang=js"
export * from "./page-action-bar.vue?vue&type=script&lang=js"
import style0 from "./page-action-bar.vue?vue&type=style&index=0&id=7af66373&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af66373",
  null
  
)

export default component.exports